import { Chart as ChartJS } from 'chart.js';
import elementShadowPlugin from '../pages/Reports/helpers/chartPlugins';

// Register shared plugin once
ChartJS.register(elementShadowPlugin as any);

// Global plugin defaults
(ChartJS.defaults.plugins as any).elementShadow = {
  enabled: true,
  color: 'rgba(0,0,0,0.18)',
  blur: 10,
  offsetX: 2,
  offsetY: 4,
};

// Elements defaults
ChartJS.defaults.elements = ChartJS.defaults.elements || {} as any;
ChartJS.defaults.elements.arc = {
  ...(ChartJS.defaults.elements.arc || {}),
  borderWidth: 8,
  borderRadius: 2,
  borderColor: 'transparent',
};

// Dataset defaults
ChartJS.defaults.datasets = ChartJS.defaults.datasets || {} as any;
// Bars: rounded corners and no skipped borders for continuity
(ChartJS.defaults.datasets as any).bar = {
  ...(ChartJS.defaults.datasets as any).bar,
  borderRadius: 6,
  borderSkipped: false,
};

// Doughnut & Pie: spacing between segments, rounded corners, hover offset
(ChartJS.defaults.datasets as any).doughnut = {
  ...(ChartJS.defaults.datasets as any).doughnut,
  spacing: 3,
  hoverOffset: 0,
  borderColor: 'transparent',
  borderRadius: 2,
  borderWidth: 8,
};

(ChartJS.defaults.datasets as any).pie = {
  ...(ChartJS.defaults.datasets as any).pie,
  spacing: 3,
  hoverOffset: 6,
  borderColor: 'transparent',
  borderRadius: 2,
  borderWidth: 8,
};
